module.exports = __webpack_public_path__ + "img/certificate-1-5.1cf87b28.jpg";